import { Button } from '@/components/Elements';
import { DownloadArticleDialog } from '@/features/analyze/components/DownloadArticle/DownloadArticleDialog';
import { useDialog } from '@/hooks/useDialog';
import { ArrowDownTrayIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';

export const DownloadArticleDialogButton = () => {
  const { t } = useTranslation();
  const { isOpen, mounted, openDialog, closeDialog } = useDialog();

  return (
    <>
      <Button
        startIcon={<ArrowDownTrayIcon className="size-6" />}
        noBordered
        onClick={openDialog}
        className="h-12 w-full rounded-none rounded-tr-lg bg-rw-sub text-xl"
        translate="no"
      >
        {t('CSVダウンロード')}
      </Button>

      <DownloadArticleDialog
        isOpen={isOpen}
        mounted={mounted}
        onClose={closeDialog}
      />
    </>
  );
};
